var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4287 5.53345H10.6322C9.18793 5.53345 8.0835 6.63788 8.0835 8.08214V21.6751C8.0835 22.015 8.25341 22.3548 8.59323 22.4397C8.93306 22.6097 9.27288 22.5247 9.52775 22.2698L14.0304 17.7672L18.5331 22.2698C18.703 22.4397 18.8729 22.5247 19.1278 22.5247C19.2128 22.5247 19.3827 22.5247 19.4676 22.4397C19.8075 22.2698 19.9774 22.015 19.9774 21.6751V8.08214C19.9774 6.63788 18.8729 5.53345 17.4287 5.53345Z",
    fill: "#1A6263"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenFill);
export default __webpack_public_path__ + "static/media/Green Fill.3b3a6718cb16b1a1303a02041f9d5588.svg";
export { ForwardRef as ReactComponent };